const RTL = "֑-߿יִ-﷽ﹰ-ﻼ";
const LTR = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿";
const isRtlRegex = new RegExp("^[^" + LTR + "]*[" + RTL + "]");
const isLtrRegex = new RegExp("^[^" + RTL + "]*[" + LTR + "]");
const emojiRegex = /\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]/g;
const getTextDirection = (text) => {
  let result = "neutral";
  if (!text) {
    return result;
  }
  const plainText = text.replace(emojiRegex, "");
  if (isRtlRegex.test(plainText)) {
    result = "rtl";
  } else if (isLtrRegex.test(plainText)) {
    result = "ltr";
  }
  return result;
};
export {
  getTextDirection
};
//# sourceMappingURL=getTextDirection.js.map
